import { PublicWebPage } from '@/features/public-web/PublicWebPage';
import { PublicWebPanel } from '@/features/public-web/PublicWebPanel';
import { PublicWebPanelBody } from '@/features/public-web/PublicWebPanelBody';
import { PublicWebPanelTitle } from '@/features/public-web/PublicWebPanelTitle';

export default function AboutWebScreen() {
  return (
    <PublicWebPage
      eyebrow="About Radious"
      title="Local discovery with the room still attached."
      body="Radious helps people find events, deals, and venue moments around San Antonio without turning the night into endless scrolling."
      actions={[
        { label: 'Browse events', href: '/events' },
        { label: 'Download app', href: '/download', variant: 'secondary' },
      ]}>
      <PublicWebPanel tone="accent">
        <PublicWebPanelTitle>For people going out</PublicWebPanelTitle>
        <PublicWebPanelBody>
          Browse what is live, what is close, and what feels worth leaving for. Radious is built
          around action: save, RSVP, follow, get directions, and move.
        </PublicWebPanelBody>
      </PublicWebPanel>
      <PublicWebPanel>
        <PublicWebPanelTitle>For venues</PublicWebPanelTitle>
        <PublicWebPanelBody>
          Venue teams use Backstage to keep their public presence current: events, recurring
          fixtures, deals, announcements, and performance context.
        </PublicWebPanelBody>
      </PublicWebPanel>
      <PublicWebPanel>
        <PublicWebPanelTitle>Why web exists</PublicWebPanelTitle>
        <PublicWebPanelBody>
          The public web layer makes Radious easier to share, search, and trust. The native app
          stays focused on the live, personal, location-native experience.
        </PublicWebPanelBody>
      </PublicWebPanel>
    </PublicWebPage>
  );
}
